const ProductCardSkeleton = () => {
    return (
        <li className="productItem">
            <div className="imgHolder">
                <div className="skeleton prdtImg" style={{ width: "100%" }} />
            </div>
            <div className="prdtCaption">
                <div className="skeleton" style={{ height: 15, width: "40%", marginBottom: 8 }} />
                <div className="skeleton" style={{ height: 18, width: "80%", marginBottom: 8 }} />
                <div className="skeleton" style={{ height: 18, width: "60%" }} />
            </div>
        </li>
    );
};

export default ProductCardSkeleton;
